import { c as _c } from "react/compiler-runtime";
import { CenterAligned, FlexColumn, FormControl, Label, Modal, ModalBody, ModalFooter, ModalFooterButton, ModalHeader, ModalHeaderTitle, SpaceBetween, TextBody, TextLabel, UnstyledButton } from "@opensea/ui-kit";
import { Wallet } from "@opensea/ui-kit/icons";
import { useCallback, useEffect, useMemo, useState } from "react";
import { useTranslations } from "use-intl";
import { useAddressInput } from "../../hooks/useAddressInput";
import { getChainArchFromAddress } from "../../lib/address";
import { CustomDestinationWalletsActions } from "../../stores/customDestinationWalletsStore";
import { WalletAddressInput } from "../WalletAddressInput/WalletAddressInput";
export const DestinationWalletSelectModal = t0 => {
  const $ = _c(66);
  const {
    chainArch,
    open,
    onClose,
    onWalletSelect
  } = t0;
  const t = useTranslations("wallet.DestinationWalletSelectModal");
  const [identifier, setIdentifier] = useState("");
  let t1;
  if ($[0] !== identifier) {
    t1 = {
      identifier
    };
    $[0] = identifier;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const addressInputProps = useAddressInput(t1);
  let t2;
  if ($[2] !== addressInputProps.resolvedAddress || $[3] !== identifier || $[4] !== onClose || $[5] !== onWalletSelect) {
    t2 = () => {
      if (addressInputProps.resolvedAddress) {
        const walletDestination = {
          identifier,
          address: addressInputProps.resolvedAddress
        };
        CustomDestinationWalletsActions.addDestinationWallet({
          identifier,
          address: addressInputProps.resolvedAddress
        });
        onWalletSelect(walletDestination);
        onClose();
      }
    };
    $[2] = addressInputProps.resolvedAddress;
    $[3] = identifier;
    $[4] = onClose;
    $[5] = onWalletSelect;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const handleSelectAddress = t2;
  const [addressInputKey, setAddressInputKey] = useState(0);
  let t3;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = () => {
      setAddressInputKey(_temp);
    };
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const resetAddressInput = t3;
  let t4;
  let t5;
  if ($[8] !== open) {
    t4 = () => {
      if (open) {
        setIdentifier("");
        resetAddressInput();
      }
    };
    t5 = [open, resetAddressInput];
    $[8] = open;
    $[9] = t4;
    $[10] = t5;
  } else {
    t4 = $[9];
    t5 = $[10];
  }
  useEffect(t4, t5);
  let t6;
  bb0: {
    if (!addressInputProps.resolvedAddress) {
      t6 = false;
      break bb0;
    }
    if (chainArch && getChainArchFromAddress(addressInputProps.resolvedAddress) !== chainArch) {
      t6 = false;
      break bb0;
    }
    t6 = true;
  }
  const isValidAddress = t6;
  let t7;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <CenterAligned className="rounded-lg border border-border-1 p-1"><CenterAligned className="size-10 rounded border border-border-1 bg-bg-primary"><Wallet size={24} /></CenterAligned></CenterAligned>;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== t) {
    t8 = t("title");
    $[12] = t;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== t8) {
    t9 = <ModalHeaderTitle>{t8}</ModalHeaderTitle>;
    $[14] = t8;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] !== chainArch || $[17] !== t) {
    t10 = chainArch === "EVM" ? t("description") : t("descriptionSolana");
    $[16] = chainArch;
    $[17] = t;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  let t11;
  if ($[19] !== t10) {
    t11 = <TextBody color="text-secondary" size="sm">{t10}</TextBody>;
    $[19] = t10;
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  let t12;
  if ($[21] !== t11 || $[22] !== t9) {
    t12 = <ModalHeader className="gap-5" variant="heroMedia">{t7}<FlexColumn className="items-center gap-1">{t9}{t11}</FlexColumn></ModalHeader>;
    $[21] = t11;
    $[22] = t9;
    $[23] = t12;
  } else {
    t12 = $[23];
  }
  let t13;
  if ($[24] !== t) {
    t13 = t("destinationAddress");
    $[24] = t;
    $[25] = t13;
  } else {
    t13 = $[25];
  }
  let t14;
  if ($[26] !== t13) {
    t14 = <Label size="sm" weight="regular">{t13}</Label>;
    $[26] = t13;
    $[27] = t14;
  } else {
    t14 = $[27];
  }
  let t15;
  if ($[28] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = () => {
      setIdentifier("");
      resetAddressInput();
    };
    $[28] = t15;
  } else {
    t15 = $[28];
  }
  let t16;
  if ($[29] !== t) {
    t16 = t("reset");
    $[29] = t;
    $[30] = t16;
  } else {
    t16 = $[30];
  }
  let t17;
  if ($[31] !== t16) {
    t17 = <UnstyledButton className="opacity-75 hover:underline hover:opacity-100" onClick={t15}><TextLabel>{t16}</TextLabel></UnstyledButton>;
    $[31] = t16;
    $[32] = t17;
  } else {
    t17 = $[32];
  }
  let t18;
  if ($[33] !== t14 || $[34] !== t17) {
    t18 = <SpaceBetween>{t14}{t17}</SpaceBetween>;
    $[33] = t14;
    $[34] = t17;
    $[35] = t18;
  } else {
    t18 = $[35];
  }
  let t19;
  if ($[36] === Symbol.for("react.memo_cache_sentinel")) {
    t19 = e => setIdentifier(e.target.value);
    $[36] = t19;
  } else {
    t19 = $[36];
  }
  let t20;
  if ($[37] !== chainArch || $[38] !== t) {
    t20 = chainArch === "EVM" ? t("destinationAddressPlaceholder") : t("destinationAddressPlaceholderSolana");
    $[37] = chainArch;
    $[38] = t;
    $[39] = t20;
  } else {
    t20 = $[39];
  }
  let t21;
  if ($[40] !== addressInputKey || $[41] !== addressInputProps || $[42] !== t20) {
    t21 = <WalletAddressInput autoFocus={true} key={addressInputKey} onChange={t19} placeholder={t20} setValue={setIdentifier} size="md" withResetButton={false} {...addressInputProps} />;
    $[40] = addressInputKey;
    $[41] = addressInputProps;
    $[42] = t20;
    $[43] = t21;
  } else {
    t21 = $[43];
  }
  let t22;
  if ($[44] !== t18 || $[45] !== t21) {
    t22 = <ModalBody className="pt-6"><FormControl label={t18}>{t21}</FormControl></ModalBody>;
    $[44] = t18;
    $[45] = t21;
    $[46] = t22;
  } else {
    t22 = $[46];
  }
  const t23 = !isValidAddress;
  let t24;
  if ($[47] !== t) {
    t24 = t("save");
    $[47] = t;
    $[48] = t24;
  } else {
    t24 = $[48];
  }
  let t25;
  if ($[49] !== handleSelectAddress || $[50] !== t23 || $[51] !== t24) {
    t25 = <ModalFooter><ModalFooterButton disabled={t23} onClick={handleSelectAddress}>{t24}</ModalFooterButton></ModalFooter>;
    $[49] = handleSelectAddress;
    $[50] = t23;
    $[51] = t24;
    $[52] = t25;
  } else {
    t25 = $[52];
  }
  let t26;
  if ($[53] !== t12 || $[54] !== t22 || $[55] !== t25) {
    t26 = <>{t12}{t22}{t25}</>;
    $[53] = t12;
    $[54] = t22;
    $[55] = t25;
    $[56] = t26;
  } else {
    t26 = $[56];
  }
  let t27;
  if ($[57] !== onClose) {
    t27 = open_0 => !open_0 && onClose();
    $[57] = onClose;
    $[58] = t27;
  } else {
    t27 = $[58];
  }
  let t28;
  if ($[59] !== t) {
    t28 = t("title");
    $[59] = t;
    $[60] = t28;
  } else {
    t28 = $[60];
  }
  let t29;
  if ($[61] !== open || $[62] !== t26 || $[63] !== t27 || $[64] !== t28) {
    t29 = <Modal content={t26} onOpenChange={t27} open={open} size="sm" title={t28} />;
    $[61] = open;
    $[62] = t26;
    $[63] = t27;
    $[64] = t28;
    $[65] = t29;
  } else {
    t29 = $[65];
  }
  return t29;
};
function _temp(prev) {
  return prev + 1;
}